export const initialState = {
  /**
   * Auth.
   */
  auth: {
    token: null,
    user: null
  },

  /**
   * Cached objects.
   */
  cache: {
    //order: null,
  },

  /**
   * Local configuration.
   * @see /src/Config.js
   */
  clientConfig: null,

  /**
   * Environment variables.
   */
  envVars: null,

  /**
   * Zones, regions...
   */
  geography: {},

  /**
   * List of items (stores, departments...)
   */
  list: {},

  /**
   * What the logged-in user is allowed to do: the roles and the flat list of permissions the
   * server sent (see services/Auth.js). Empty for a guest.
   */
  permissions: [],
  roles: [],

  /**
   * Configuration data from server.
   */
  serverConfig: null,

  /**
   * User preferences.
   */
  settings: {
    // null = never chosen on this device: the language of a page is the one written in its address,
    // and this is only the last choice made here (see services/Language).
    language: null,
    // null = automatic: the dates are written in the timezone the browser declares (see
    // services/Timezone).
    timezone: null,
  },

  system: {
    loading: {}
  }
}